import {useEffect, useRef} from 'react'
import {Base64} from "js-base64";
import {useNavigate, useSearchParams} from "react-router-dom";
import {getItem} from "../../../lib/localstorage";
import useAuthenticatedCallback from "../../../hooks/useAuthenticatedCallback";
import {demoPages} from "../../../menu";

const SimpleLogin = () => {
    const [searchParams,] = useSearchParams()
    const navigate = useNavigate()
    const isCalledRef = useRef(false);
    const authenticatedCallback = useAuthenticatedCallback();

    const isValidAccessToken = (email) => {
        const token = getItem('access-token');

        if (!token || !email) return false;

        try {
            const [, payload] = token.split('.');
            const tokenInfo = JSON.parse(Base64.decode(payload));

            return (tokenInfo.email?.toLowerCase() === email.toLowerCase())
                && (tokenInfo.exp > Math.floor(Date.now() / 1000));
        } catch (error) {
            console.error('JWT 확인 실패:', error);
            return false;
        }
    };

    useEffect(() => {
        // 리렌더링 되더라도 1번만 실행되도록
        if (isCalledRef.current) return;

        isCalledRef.current = true;

        // 구분자(_)로 나눠져있는 state와 requestId를 복호화
        const state = searchParams.get('data')
            ? JSON.stringify(
                (([state, requestId]) => ({state, requestId}))
                (Base64.decode(searchParams.get('data')).split('_'))
            )
            : searchParams.get('url') || null;

        const email = searchParams.get('email')
            ? Base64.decode(searchParams.get('email'))
            : null;

        if (isValidAccessToken(email)) {
            // 같은 사용자의 유효한 JWT가 있으면 곧바로 다음 프로세스 진행
            void authenticatedCallback(state);
        } else {
            if (state && email) {
                navigate('/' + demoPages.simplePasswordLogin.path, {
                    state: {
                        callbackState: state,
                        email
                    }
                });
            } else {
                // 근태시스템 바로가기의 경우 로그인창으로 이동
                navigate('/' + demoPages.login.path);
            }
        }

    }, [searchParams])
}

export default SimpleLogin